import { object, string, func, number, bool } from 'prop-types'
import { PureComponent } from 'react'
import { StoryfirstUnit } from '@opallabs/concepts'
import { BudgetPanel } from '../BudgetPanel'

const hasBudgetInFamilyTree = (budget, context) =>
  budget.value !== null ||
  budget.story_allocation !== null ||
  budget.moment_allocation !== null ||
  (context === 'moment' && budget.post_spend !== null) ||
  (context === 'story' &&
    (budget.moment_spend !== null || budget.post_spend !== null))

export default class BudgetPanelManager extends PureComponent {
  static propTypes = {
    budget: object,
    context: string,
    getBudget: func,
    id: number,
    refetchBudget: bool,
  }

  static defaultProps = {
    budget: {},
  }

  componentDidMount() {
    const { getBudget, context, id } = this.props

    getBudget({ id, context })
  }

  componentDidUpdate() {
    const { context, getBudget, id, refetchBudget } = this.props

    if (refetchBudget) getBudget({ id, context })
  }

  render() {
    const { budget, context } = this.props
    if (!hasBudgetInFamilyTree(budget, context) || !budget.id) {
      return null
    }

    /** @type number */
    let max
    switch (context) {
      case StoryfirstUnit.Story:
        max = budget.value
        break
      case StoryfirstUnit.Moment:
        max = budget.value
        break
      case StoryfirstUnit.Content:
        max = budget.moment_allocation
        break
      default:
        max = 0
    }

    return (
      <BudgetPanel
        {...this.props}
        momentValue={budget.moment_spend || 0}
        contentValue={budget.post_spend || 0}
        max={max}
      />
    )
  }
}
